module.exports = __webpack_public_path__ + "static/media/Chase_Bank.1311a297.png";